import { CronInterval } from '../../enums/schedules/cron-interval';
import { CronScheduleProps } from '../../interfaces/schedule-tasks/cron-schedule-props';
import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';

/**
 * Configuration for a ScheduleTask trigger — runs the flow on a recurring schedule
 * defined by `cronProps`. The `interval` field labels the coarse time-unit; the
 * actual cron string is built at runtime via `BuildCronString(cronProps)`.
 */
export class ScheduleTaskConfig extends DestinationTaskConfigBase {
	/**
	 * When true, the schedule is active and the flow will run automatically.
	 * When false, the schedule is paused and will not enqueue jobs.
	 * @default false
	 */
	enabled = false;

	/**
	 * Coarse time-unit label for the schedule (minute=0, hour=1, day=2, week=3, month=4, year=5).
	 * Used for display/labelling; fine-grained timing is controlled by `cronProps`.
	 * @default CronInterval.minute
	 */
	interval = CronInterval.minute;

	/**
	 * Fine-grained schedule definition converted to a 5-part cron string by `BuildCronString`.
	 * Controls the exact minutes, hours, days, months, and day-of-week the flow runs.
	 */
	cronProps = new CronScheduleProps();

	constructor(init?: Partial<ScheduleTaskConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
